import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Location } from '@angular/common';
import { Incidente } from '../incidente/incidente';
import { IncidenteService } from '../incidente/incidente.service';
import { RequestOptions, Headers, Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/Rx';

@Component({
  selector: 'app-busca',
  templateUrl: './busca.component.html',
  styleUrls: ['./busca.component.css'],
  providers: [
    IncidenteService
  ]
})
export class BuscaComponent implements OnInit {
  incidente: Incidente;
  resposta: string;

  constructor(private incidenteService: IncidenteService,private route: ActivatedRoute,
  private location: Location,
  private router: Router,
  private http: Http) {
    this.incidente = new Incidente();
    this.http = http;
  }

  ngOnInit() {
  }

  buscar(): void {
      if (!this.incidente.id) {
        this.incidenteService.buscarStatus(this.incidente.protocolo)
            .then((resposta) => {this.resposta = resposta;});
      }

  }

}



// WEBPACK FOOTER //
// ./src/app/busca/busca.component.ts